/* eslint-env browser */
/* eslint-disable no-console */
import axios from '../axios';
import {toast} from 'react-toastify';
import * as validationTypes from '../constants/ValidationConstants';
import * as apiTypes from '../constants/ApiConstants';
import * as types from '../constants/ActionTypes';
import * as appConstants from '../constants/ApplicationConstants';
import {
    updateState,
    requestErrored,
    loginFailed
} from './CommonActions';
import {setSelectedSoldTos} from "./InvoiceActions";

export function setLoginChecked(isChecked, isLoggedIn) {
    return {
        type: types.SET_LOGIN_CHECKED,
        payload: {
            checked: isChecked,
            isLoggedIn: isLoggedIn,
        }
    }
}

export function setIsLoggedIn(isLoggedIn) {
    return {
        type: types.SET_IS_LOGGED_IN,
        payload: isLoggedIn,
    }
}

export function setLastUrl(url) {
    return {
        type: types.SET_LAST_URL,
        payload: url,
    }
}

export function login(dispatch, email, pasword) {
    const loginRequest = {login: email, password: pasword};
    return axios.post(apiTypes.LOGIN_URL, loginRequest)
        .then((response) => {
            if (response.status === 200) {
                // store token in session storage.
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('refreshToken', response.data.refreshToken);
                axios.instance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                updateState(dispatch, types.SET_IS_LOGGED_IN, response.data.isLoggedIn);
            } else {
                toast.error(validationTypes.CREDENTIALS_INVALID, {position: toast.POSITION.TOP_RIGHT});
            }
        })
        .catch((error) => {
            // requestErrored(dispatch, error, validationTypes.AUTHENTICATION_ERROR);
            if (error && error.response && error.response.statusText === 'Unauthorized') {
                loginFailed(dispatch, error);
            } else {
                requestErrored(dispatch, error, validationTypes.AUTHENTICATION_ERROR);
                throw error.response.statusText;
            }
        });
}

export function refreshToken(dispatch) {
    let token = sessionStorage.getItem('refreshToken');
    const requestBody = {refreshToken: token};
    axios.post(apiTypes.REFRESH_TOKEN_URL, requestBody)
        .then((response) => {
            if (response.status === 200) {
                //store token in session storage.
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('refreshToken', response.data.refreshToken);
                axios.instance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
            }
        })
        .catch((error) => {
            // requestErrored(dispatch, error, validationTypes.AUTHENTICATION_ERROR);
            if (error && error.response && error.response.statusText === 'Unauthorized') {
                loginFailed(dispatch, error);
            } else {
                requestErrored(dispatch, error, validationTypes.AUTHENTICATION_ERROR);
            }
        });
}

export function getUser(dispatch, email) {
    const finalGetUser = `${apiTypes.GET_USER_URL}`;
    return axios.post(finalGetUser, '')
        .then((userData) => {
            if (userData.status === 200 && userData.data) {
                if (userData.data && userData.data) {
                    updateState(dispatch, types.GET_USER_SUCCESS, userData.data);
                    updateState(dispatch, types.SET_ACCOUNT_TYPE, mapPrimaryAccountType(userData.data.PrimaryAccountTypeId));
                }
                return userData.data;
            } else {
                return null;
            }
        })
        .catch((err) => {
            if (err && err.response && err.response.statusText === 'Unauthorized') {
                requestErrored(dispatch, err, validationTypes.CREDENTIALS_INVALID);
            } else {
                requestErrored(dispatch, err, validationTypes.GET_USER_ERROR);
            }
        });
}

export function mapPrimaryAccountType(primaryAccountTypeId) {
    switch (primaryAccountTypeId) {
        case 1:
            return appConstants.SOLD_TO_COMPARE;
        case 2:
            return appConstants.PAYER_COMPARE;
        case 3:
            return appConstants.ACCOUNT_PAYER_ALL;
        default:
            return appConstants.SOLD_TO_COMPARE;

    }
}

/**
 * Dispatches HTTP request to get users Accounts. These accounts show up on the header of the application.
 * @param dispatch
 * @param userId
 * @param clearSecondary
 */
export function getUserCustomers(dispatch, userId = "", clearSecondary = true) {

    const body = {};
    let finalGetUserPayerUrl = `${apiTypes.USER_PAYERS_URL}`;
    let id = sessionStorage.getItem('impersonatedUserId');
        userId = parseInt(id, 10);

    if (userId) {
        finalGetUserPayerUrl = `${finalGetUserPayerUrl}${'userid='}${userId}`;
    }
    axios.post(finalGetUserPayerUrl, body)
        .then((userData) => {
            if (userData.status === 200 && userData.data && userData.data.HeaderItems) {
                updateState(dispatch, types.GET_PRIMARY_ACCOUNTS_SUCCESS, {accounts: userData.data.HeaderItems, clearSecondary});
                if(clearSecondary){
                    dispatch(setSelectedSoldTos(userData.data.HeaderItems[0].DropDownItems.map(account => account.PrimaryAcct)));
                }
                if (typeof userId !== 'undefined') {
                    updateState(dispatch, types.UPDATE_IMPERSONATE_USER_ID, userId);
                }
            }
        })
        .catch((err) => {
            if (err && err.response && err.response.statusText === 'Unauthorized') {
                requestErrored(dispatch, err, validationTypes.CREDENTIALS_INVALID);
            } else {
                requestErrored(dispatch, err, validationTypes.GET_USER_PAYER_ERROR);
            }
        });
}

export function Logout(dispatch) {
    return axios.post(apiTypes.LOGOUT_URL)
        .then((response) => {
            dispatch({type: types.LOGOUT});
        })
        .catch((error) => {
            requestErrored(dispatch, error, validationTypes.AUTHENTICATION_ERROR);
        });
}

export function ResetPassword(dispatch, currentPassword, newPassword, confirmNewPassword) {
    const resetPasswordRequest = {
        CurrentPassword: currentPassword,
        NewPassword: newPassword,
        ConfirmNewPassword: confirmNewPassword
    };
    axios.post(apiTypes.RESET_PASSWORD, resetPasswordRequest)
        .then((userData) => {
            if (userData.status === 200 && userData.data.message === appConstants.SUCCESS) {
                toast.success(validationTypes.RESET_PASSWORD_SUCCESS, {position: toast.POSITION.TOP_RIGHT});
                updateState(dispatch, types.UPDATE_PASSWORD_RESPONSE, userData.data.message);
            } else {
                toast.warn(userData.data.message, {position: toast.POSITION.TOP_RIGHT});
                updateState(dispatch, types.UPDATE_PASSWORD_RESPONSE, userData.data.message);
            }
        })
        .catch((err) => {
            if (err && err.response && err.response.statusText === 'Unauthorized') {
                requestErrored(dispatch, err, validationTypes.CREDENTIALS_INVALID);
            } else {
                requestErrored(dispatch, err, validationTypes.RESET_PASSWORD_ERROR);
            }
        });
}

